import { semanticColors } from "@louise/theme/tokens";

export const calendarMarkerColors = {
  med: "#D8843B",
  visit: "#6F625A",
  lab: "#9A8D84",
  period: "#9E2F28",
  fertile: "#77794A",
  fallback: "rgba(111,98,90,0.42)",
} as const;

export const calendarCheckInColors = {
  foreground: semanticColors.onDark.text.primary,
  navigationForeground: semanticColors.onDark.text.secondary,
  dayLabel: semanticColors.onDark.text.tertiary,
  weekDate: semanticColors.onDark.text.primary,
  monthDate: semanticColors.onDark.text.secondary,
  cellBackground: semanticColors.onDark.fill.subtle,
  selectedCellBackground: "rgba(255,247,239,0.32)",
  selectedCellBorder: "rgba(255,247,239,0.85)",
} as const;

export const calendarViewColors = {
  weekCellBackground: semanticColors.surface.glass,
  monthCellBackground: "rgba(255,255,255,0.24)",
  selectedCellBackground: semanticColors.accent.tint,
  selectedCellBorder: semanticColors.accent.default,
} as const;
